import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addUpdateQuizMarksRes;
export const addUpdateQuizMarksTodo = createAsyncThunk('addUpdateQuizMarks', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/add_update_quiz_marks',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "total_marks": data.total,
                "passing_marks": data.passing,
                "status": "active",
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addUpdateQuizMarksRes = res.data
    } catch (error) {
        return addUpdateQuizMarksRes = error.response.data
    }
})